export const DATASTAR_FETCH_EVENT = 'datastar-fetch'
export const DATASTAR_PROP_CHANGE_EVENT = 'datastar-prop-change'
export const DATASTAR_READY_EVENT = 'datastar-ready'
export const DATASTAR_SCOPE_CHILDREN_EVENT = 'datastar-scope-children'
export const DATASTAR_SIGNAL_PATCH_EVENT = 'datastar-signal-patch'
export const DOCUMENT = document
export const HTMLInput = HTMLInputElement
export const MutationObserverClass = MutationObserver
